module.exports = __webpack_public_path__ + "img/athletic-bilbao-logo-icon.4825f267.png";